import 'bootstrap';

class TeamModals {
  constructor() {
    const teamMembers = document.querySelectorAll(".team-member");
    
    if (teamMembers.length > 0 ) {
      const modal = document.querySelector('#team-modal');

      teamMembers.forEach((member) => {
        const modalContent = member.querySelector('.team-member__reveal').innerHTML;
        const link = member.querySelector('.modal-trigger');
        link.addEventListener('mouseover',(e) => {
          
          modal.querySelector('.modal-body').innerHTML = modalContent;

        });
      });
    }
  }
}

export default new TeamModals;
